import React, { useState } from 'react';
import ReactDatePicker from 'react-datepicker';
import MaskedTextInput from 'react-text-mask';
import 'react-datepicker/dist/react-datepicker.css';
import { registerLocale } from 'react-datepicker';
import { ru } from 'date-fns/esm/locale';
import styles from './datepicker.module.css';

// icons
import calendar from '../../../brand/generated/input/calendar.svg';

import { textStyles } from '../../../constants/textStyles';
import { colors } from '../../../constants/colors';
import dayjs from 'dayjs';

registerLocale('ru', ru);

const Datepicker = ({ label, onChange, placeholder, value, defaultValue, disabled, required, isClearable }) => {
  const [startDate, setStartDate] = useState(() => {
    if (!defaultValue) return null;
    const d = new Date(defaultValue);
    return Number.isNaN(d.getTime()) ? null : d;
  });

  // Дату поле держит в своём state, поэтому снаружи её было не сбросить: чистишь
  // значение в форме (крестик на применённом фильтре) — в поле по-прежнему дата.
  // Синхронизируем только очистку: в остальном поле остаётся неуправляемым.
  React.useEffect(() => {
    if (value === null || value === undefined || value === '') setStartDate(null);
  }, [value]);

  return (
    <div className={styles.input}>
      <label style={textStyles.fieldLabel}>{label} {required && <span style={{ color: colors.red }}>*</span>}</label>
      <ReactDatePicker
        customInput={<MaskedTextInput placeholder='ДД.ММ.ГГГГ' type="text" mask={[/\d/, /\d/, '.', /\d/, /\d/, '.', /\d/, /\d/, /\d/, /\d/]} />}
        locale={'ru'}
        dateFormat="dd.MM.yyyy"
        selected={startDate}
        isClearable={isClearable}
        shouldCloseOnSelect={true}
        onChange={(date) => {
          if (!date) {
            setStartDate(null);
            onChange(null);
            return;
          }

          const next = dayjs(date).hour(12).toDate();
          setStartDate(next);
          onChange(next);
        }}
        placeholderText={placeholder}
        disabled={disabled}
      />
      <img src={calendar} alt="Icon" />
    </div>
  );
};

export default Datepicker;
